<template>
  <div class="verification">
    <el-button size="small" type="primary" @click="send" :nums="num" :disabled="disabled || (!enable)">{{content}}</el-button>
  </div>
</template>

<script>
export default {
  name: 'verification',
  data() {
    return {
      content: '获取验证码',
      disabled: false,
      num: this.nums
    }
  },
  props: {
    enable: {
      type: Boolean,
      default: true
    },
    nums: {
      type: Number,
      default: 60
    },
    stop: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  watch: {
    stop(val) {
      if (!val) {
        this.disabled = true
        const timer = setInterval(() => {
          this.num--
          this.content = `重新获取(${this.num}s)`
          if (this.num === 0) {
            this.num = this.nums
            this.disabled = false
            this.content = '重新获取'
            clearInterval(timer)
          }
        }, 1000)
      }
    }
  },
  methods: {
    setContent(val) {
      this.content = val
    },
    send() {
      this.$emit('send')
    }
  }
}

</script>
<style lang='scss' scoped>
.verification{
  display: inline-block;
  .el-button{
    width: 130px;
    margin-left: 8px;
  }
}
</style>
